import React, { PureComponent } from 'react';
import { Field, FieldArray, FormSection } from 'redux-form';
import { RenderDynamicForm } from '../index';

const RenderServices = ({ listOfValues = [], fields }) => {
  return (
    <div className="dynamic-field">
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => (fields.push({}))}>ADD NEW SECTION
      </button>
      {
        fields.map((fieldObj, index) => {
          return (
            <section
              key={index}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => (fields.remove(index))}>Remove
              </button>
              <div className="row">
                <div className="col-lg-3">
                  <div
                    className="form-group">
                    <label>Component</label>
                    <div>
                      <Field
                        className="form-control"
                        name={`${fieldObj}.component`}
                        component="select">
                        <option/>
                        <option value="Text">Rich Text</option>
                        <option value="Image">Image</option>
                        <option value="List">List</option>
                        <option value="Video">Video</option>
                      </Field>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {
                  listOfValues.length > 0 && <FormSection name={`${fieldObj}`}>
                    <RenderDynamicForm name={`${fieldObj}`} component={listOfValues[index].component}/>
                  </FormSection>
                }
              </div>
            </section>
          );
        })
      }
    </div>
  );
};

class DynamicField extends PureComponent {

  render() {
    const { myValues } = this.props;
    console.log(myValues)
    return (
      <div>
        <FieldArray
          listOfValues={myValues.sections}
          name="sections"
          component={RenderServices}/>
      </div>
    );
  }
}

export default DynamicField;



// WEBPACK FOOTER //
// ./src/components/dynamic-field/index.js